/** @format */

import cn from "classnames";
import React from "react";
import MaterialSpinner from "../MaterialSpinner";
import s from "./OverlayLoader.module.scss";

type OverlayLoaderV2Props = {
  show?: boolean;
  styleProp?: any;
  loader?: React.JSX.Element;
};

export const OverlayLoader = ({
  show = true,
  loader = <MaterialSpinner width={64} height={64} />,
  styleProp = {},
}: OverlayLoaderV2Props) => {
  if (show) {
    return (
      <div
        style={styleProp}
        className={cn("cmn_fullscreen_fixed", s.overlay_loader)}
      >
        {loader}
      </div>
    );
  }
  return null;
};
